<template>
  <div class="pv">
    <div class="pv__head">
      <span class="pv__count">{{ count }}</span>
      <span class="pv__count-label">款商品已同步</span>
    </div>
    <div v-for="(pl, i) in plats" :key="pl" class="pv__bar-row">
      <span class="pv__bar-name" :style="{ color: colors[i] }">{{ pl }}</span>
      <div class="pv__bar">
        <div class="pv__bar-fill" :style="{ width: platforms[i] + '%', background: `linear-gradient(90deg, ${colors[i]}, #D4A946)` }"></div>
      </div>
      <span class="pv__bar-val" :style="{ color: colors[i] }">{{ platforms[i] }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevCloud',
  props: { run: { type: Boolean, default: false } },
  data() {
    return {
      count: 0,
      platforms: [0, 0, 0, 0, 0, 0, 0],
      timer: null,
      plats: ['抖店', '微店', '淘宝', '京东', '快手', '拼多多', '小红书'],
      colors: ['#00F0FF', '#FF6B35', '#FF6B35', '#E8321A', '#FF3B30', '#E44D4D', '#FF2C55']
    }
  },
  watch: {
    run(v) {
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.count = 0; this.platforms = [0, 0, 0, 0, 0, 0, 0]; return }
      this.timer = setInterval(() => {
        this.count = Math.min(this.count + 8, 500)
        this.platforms = this.platforms.map(p => Math.min(p + 4, 100))
      }, 80)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { width: 100%; }
.pv__head { text-align: center; margin-bottom: 10px; }
.pv__count { font-family: Inter, monospace; font-size: 22px; font-weight: 700; color: #D4A946; }
.pv__count-label { font-size: 12px; color: rgba(220, 215, 240, .6); margin-left: 4px; }
.pv__bar-row { display: flex; align-items: center; gap: 8px; margin-bottom: 7px; }
.pv__bar-name { font-size: 11px; width: 44px; flex-shrink: 0; }
.pv__bar { flex: 1; height: 5px; border-radius: 3px; background: rgba(255, 255, 255, .08); overflow: hidden; }
.pv__bar-fill { height: 100%; border-radius: 3px; transition: width .08s; }
.pv__bar-val { font-family: Inter; font-size: 10px; width: 30px; text-align: right; }
</style>
